import { Component, ViewChild } from '@angular/core';
import { MatExpansionPanel, MatDatepickerInputEvent } from '@angular/material';
import * as moment from 'moment';
import { Moment } from 'moment';
import { ListadoTareasComponent } from './listado-tareas/listado-tareas.component';

@Component({
  selector: 'app-listar-tareas',
  templateUrl: './listar-tareas.component.html',
  styleUrls: ['./listar-tareas.component.scss']
})
export class ListarTareasComponent {
  mesSeleccionado = (new Date()).getMonth() + 1;
  diaSeleccionado = moment();

  @ViewChild('listadoTareasMes') listadoTareasMes: ListadoTareasComponent;
  @ViewChild('listadoTareasDia') listadoTareasDia: ListadoTareasComponent;
  @ViewChild('panelDia') panelDia: MatExpansionPanel;
  @ViewChild('panelMes') panelMes: MatExpansionPanel;

  constructor() { }

  compararNumeroMes(mes1: any, mes2: any): boolean | null {
    if (mes1 && mes2) {
      return mes1 == mes2;
    }

    return false;
  }

  /**
   * Al cambiar el día traer sus tareas
   * @param event 
   */
  onChangeDia(event: MatDatepickerInputEvent<Moment>): void {
    this.diaSeleccionado = event.value;
    this.traerTareasDia();
  }

  /**
   * traer tareas del día seleccionado
   * desde que comienza hasta que termina el día
   */
  traerTareasDia(): void {
    this.listadoTareasDia.traerTareas(
      moment(this.diaSeleccionado.format('YYYY-MM-DD 00:00:00')),
      moment(this.diaSeleccionado.format('YYYY-MM-DD 23:59:59'))
    );
  }

  /**
   * traer tareas del número de mes seleccionado
   * desde el día 1 hasta el último día del mes seleccionado
   */
  traerTareasMes(): void {
    var yearYYYY = (new Date()).getFullYear();
    var monthM = (this.mesSeleccionado < 10) ? "0" + this.mesSeleccionado : this.mesSeleccionado;
    var lastDayOfMonth = (new Date(yearYYYY, (+monthM), 0)).getDate();

    this.listadoTareasMes.traerTareas(
      moment(yearYYYY + '-' + monthM + '-01T00:00:00'),
      moment(yearYYYY + '-' + monthM + '-' + lastDayOfMonth + 'T23:59:59')
    );
  }

  actualizarListado(): void {
    if (this.panelDia.opened) {
      this.traerTareasDia();
    }

    if (this.panelMes.opened) {
      this.traerTareasMes();
    }
  }

  clearTareasMes(): void {
    this.listadoTareasMes.clear();
  }

  clearTareasDia(): void {
    this.listadoTareasDia.clear();
  }
}
